import React, { createContext, useState } from 'react'
import CONFIG from '../config'
import { geoCode } from '../services/map/map'
const axios = require('axios')
const _ = require('lodash')

export const Context = createContext()
export const ContextProvider = ({ children }) => {
  const [currLocation, setcurrLocation] = useState(null)
  const [point, setPoint] = useState(null)
  const [nearByCenters, setNearByCenters] = useState(null)
  const [selectedClinic, setSelectedClinic] = useState(null)
  const [originAddress, setOriginAddress] = useState('')
  const [token, setToken] = useState(null)
  const [filters, setFilters] = useState({ range: 100, sort: 'distance' })

  const handleClinicClick = (id) => {
    if (selectedClinic === id) return
    setSelectedClinic(id)
  }

  const handleCurrLocation = (location) => {
    setcurrLocation(location)
  }

  const getLocationAddress = (location) => {
    geoCode(location).then(result => {
      if (result) setOriginAddress(result)
    })
  }

  const handlePoint = (location) => {
    setPoint(location)
  }

  const handleFilterRange = async (dist) => {
    setFilters({ range: dist, sort: 'distance' })
    const position = point || currLocation // if user selected pincode, use pincode else set current location
    await getNearbyCenters(position, { distance: +dist })
  }

  const handleToken = (val) => { // set cookies
    setToken(val)
    if (val === null) document.cookie = 'fmtaccount=;path=/'
    else document.cookie = 'fmtaccount=' + val + ';path=/'
  }

  const getNearbyCenters = async (location, filter) => {
    const { lat, lng } = location

    if (!location) {
      return
    }

    if (!filter && _.isEqual(location, currLocation) && !_.isEmpty(nearByCenters)) {
      return
    }
    try {
      setNearByCenters(null)
      let apiUrl = `${CONFIG.api_url}/nearby/?lat=${lat}&lng=${lng}`

      if (!_.isEmpty(filter) && filter.distance) {
        apiUrl += `&distance=${filter.distance}`
      } else {
        setFilters({ range: 100, sort: 'distance' }) // default filter values
      }

      const { data } = await axios.get(apiUrl)
      if (_.isEmpty(data)) {
        setNearByCenters([])
        setSelectedClinic(null)
        return
      }
      const listOfCenters = data // show first 5 entries
      setNearByCenters(listOfCenters)
      setSelectedClinic(null)
    } catch (error) {
      setNearByCenters([])
      console.error(error.message)
    }
  }

  const handleSortRangeSelect = (sortValue) => {
    const list = [...nearByCenters]
    setFilters({ range: filters.range, sort: sortValue })

    if (sortValue === 'time') {
      list.sort((a, b) => a.duration.value - b.duration.value)
    } else {
      list.sort((a, b) => a.distance.value - b.distance.value)
    }
    setNearByCenters(list)
  }

  const value = { getNearbyCenters, handleClinicClick, selectedClinic, nearByCenters, handleCurrLocation, currLocation, handleFilterRange, handlePoint, point, handleSortRangeSelect, originAddress, handleToken, token, filters, getLocationAddress }

  return (
    <Context.Provider value={value}>
      {children}
    </Context.Provider>
  )
}
